import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';

@Component({
  selector: 'app-campaign-3-view-products',
  templateUrl: './campaign-3-view-products.component.html',
  styleUrls: ['./campaign-3-view-products.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3ViewProductsComponent implements OnInit {
  
  @Input() filters: Array<{key: string, value: string}> = [];

  paginationType: number = Campaign3KontableComponent.ServerPagination;
  
  show = {
    table: false
  }
  
  constructor(
    private srvCampaign3: Campaign3Service
  ) {}

  ngOnInit() {
    this.show.table = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/view-products/campaign-3-view-products.component.ts